import { useMutation, useQueryClient } from '@tanstack/react-query';

import { startCalendarOAuth, updateCalendarConnection, disconnectCalendar } from '../../api/crmApi';
import { integrationsKeys } from '../integrations/queries';

import { calendarKeys } from './keys';

export function useStartCalendarOAuth() {
	return useMutation({
		mutationFn: (provider) => startCalendarOAuth(provider),
		// Redirect to provider's OAuth consent page on success
		onSuccess: (data) => {
			if (data.url) {
				window.location.href = data.url;
			}
		},
	});
}

export function useUpdateCalendarConnection() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ id, settings }) => updateCalendarConnection(id, settings),
		// Refresh both calendar connections and integrations overview
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: calendarKeys.connections() });
			qc.invalidateQueries({ queryKey: integrationsKeys.list() });
		},
	});
}

export function useDisconnectCalendar() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (id) => disconnectCalendar(id),
		// Refresh calendar connections, events, and integrations overview
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: calendarKeys.all });
			qc.invalidateQueries({ queryKey: integrationsKeys.list() });
		},
	});
}
